import { attr, html } from '@tempots/dom'

export function Copyright() {
  const startYear = 2025
  const year = new Date().getFullYear()
  const years = startYear === year ? `${startYear}` : `${startYear}-${year}`
  return html.p(
    attr.class('text-sm text-gray-400 text-center'),
    '© ',
    years,
    ' ResumeHeaders. All rights reserved.'
  )
}
